import { IBannerInlinePlaceholderProps } from '@tekface/smart-activation';
import { ProductDetailProvider } from 'contexts';
import { formatExtraPromotions } from 'helpers';
import { useTenantConfig, useVnpayPromotion } from 'hooks';
import { getServerSidePropsDetail } from 'modules/product-detail/shared';
import dynamic from 'next/dynamic';
import React from 'react';
import { PROMOTION_TYPE, ProductResponse } from 'types';
import { useCustomPromotion } from '../_module/hooks/useCustomPromotions';

const NewDetailPage = dynamic(() =>
  import('modules/product-detail/desktop').then((mod) => mod.NewDetailPage),
);

const DetailPage = dynamic(() =>
  import('modules/product-detail/desktop').then((mod) => mod.DetailPage),
);

export interface ProductDetailsProps {
  serverProduct: ProductResponse;
  inlineBanners?: IBannerInlinePlaceholderProps<{}>['banners'];
}
const ProductDetails: React.FC = () => {
  const { vnpayPromotions } = useVnpayPromotion('phongvu_vnpay_promotion');
  const { customPromotions } = useCustomPromotion();
  const { epicOmni1643 } = useTenantConfig();
  const extraPromotions = formatExtraPromotions(
    vnpayPromotions,
    PROMOTION_TYPE.magento,
  );
  const extraCustomPromotions = formatExtraPromotions(
    customPromotions,
    PROMOTION_TYPE.customMagento,
  );

  if (epicOmni1643)
    return (
      <NewDetailPage
        showRelatedPromotion={true}
        extraPromotions={[...extraPromotions, ...extraCustomPromotions]}
      />
    );

  return (
    <DetailPage
      extraPromotions={[...extraPromotions, ...extraCustomPromotions]}
    />
  );
};
const ProductDetailsPage: React.FunctionComponent<ProductDetailsProps> = ({
  serverProduct,
  inlineBanners,
}: ProductDetailsProps) => {
  return (
    <ProductDetailProvider
      serverProduct={serverProduct}
      inlineBanners={inlineBanners}
    >
      <ProductDetails />
    </ProductDetailProvider>
  );
};
export const getServerSideProps = getServerSidePropsDetail;
export default ProductDetailsPage;
